import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue';
import 'animate.css';
import VueLazyload from 'vue-lazyload'

const app = createApp(App);
app.use(ElementPlus);
app.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
  });
app.mount('#app');